// extracted by mini-css-extract-plugin
module.exports = {"dialog":"InfoDialog_dialog__T63KZ","dialogTitle":"InfoDialog_dialogTitle__11nHK","actions":"InfoDialog_actions__3Hw5G","closeButton":"InfoDialog_closeButton__3Mi4T"};